export default (result) => result;
